import React from "react";
import BoxComponent from "./Box";
import Figures from "./Figures";

export default function FiguresBox({ dashboardData, loading }) {
  // Default values if data is not available or loading
  const totalRevenue = dashboardData?.totalRevenue || 0;
  const completedRides = dashboardData?.completedRides || 0;
  const inProgressRides = dashboardData?.inProgressRides || 0;
  // Format the revenue with currency symbol and commas
  const formattedRevenue = loading
    ? "Loading..."
    : `$ ${totalRevenue.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
  const formattedCompletedRides = loading
    ? "Loading..."
    : completedRides.toLocaleString("en-US");
  const formattedInProgressRides = loading
    ? "Loading..."
    : inProgressRides.toLocaleString("en-US");

  return (
    <BoxComponent display="flex" justifyContent="space-between" padding="20px">
      <Figures
        title="Total Revenue Generated"
        numbers={formattedRevenue}
        img="Images/revenue.png"
      />
      <Figures
        title="No. of Completed Rides"
        numbers={formattedCompletedRides}
        img="Images/completed-ride.png"
      />
      <Figures
        title="No. of Current Rides"
        numbers={formattedInProgressRides}
        img="Images/current-ride.png"
      />
    </BoxComponent>
  );
}
